module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M9.016 18H12v-3c0-.552.462-1 1.016-1h2c.552 0 .984.448.984 1v3h3.016c.552 0 .984.448.984 1v2c0 .552-.432 1-.984 1H16v3c0 .552-.432 1-.984 1h-2A1.013 1.013 0 0 1 12 25v-3H9.016A1.013 1.013 0 0 1 8 21v-2c0-.552.462-1 1.016-1zm10-8A1.013 1.013 0 0 1 18 9V1c0-.552-.432-1-.984-1h-15A2.012 2.012 0 0 0 0 2v28c0 1.106.91 2 2.016 2h24A1.985 1.985 0 0 0 28 30V11c0-.552-.432-1-.984-1h-8zM20 1v6c0 .552.462 1 1.016 1h6c.552 0 .684-.316.292-.708L20.714.706C20.324.316 20 .448 20 1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/add-document-1.js
// module id = 975
// module chunks = 14